import {
  Page,
  commonValues
} from './common-modules.js';

export {
  qtCalcMod,
  methodBox,
  designSizeUserInterface,
  designSizeInput,
  optionSettingBoxHover,
  inputNumIncrAndDecr,
  printColorSelect,
  colorCodeSelect,
  inputFromSavedDirect,
  switchColorChangePattern
};

var numeral = require('numeral'),
    isDisabled = ($elm) => $elm.is('[disabled]') || $elm.prop('disabled') || $elm.is('[readonly]') || $elm.hasClass('disabled') || !!$elm.closest('.disabled').length,
    toNumber = (str) => numeral(String(str || "").replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)) || 0).value();

/*
  カラー・サイズ情報選択画面
  仕上加工オプション画面
*/
const qtCalcMod = (() => {
  let qtCalcParentClassName = 'js-qt-calc';

  //数量合計計算
  // jq-qt-calc-wrap
  //   js-qt-calc
  //     js-qt-calc-type
  //       js-type-proof-total
  //       js-type-mass-total
  //       js-type-manual-total
  //       input.js-qt-input-proof
  //       input.js-qt-input-prod
  //       input.js-qt-input-manual
  //
  //     js-prod-proof-total
  //     js-prod-mass-total
  //     js-prod-manual-total
  //
  //   js-proof-total
  //   js-mass-total
  //   js-manual-total
  const calcTotal = ($elm) => {
    // イベントの発火した input 要素を含むブロック内が対象
    const $calcBlock = $elm.closest('.js-qt-calc-wrap'),
      sumUp = ($elements, $totalElement, input) => {
        const total = $elements.toArray().reduce((accumulator, current) => {
          const value = input ? $(current).val() : $(current).text();

          return accumulator + toNumber(value);
        }, 0);

        $totalElement.text(numeral(total).format('0,0'));
      };

    $calcBlock.find('.js-qt-calc').each((index, elm) => {
      const $elm = $(elm);

      $elm.find('.js-qt-calc-type').each((index, elm) => {
        const $elm = $(elm);
        // input タグからのタイプごとに集計
        sumUp($elm.find('input.js-qt-input-proof'), $elm.find('.js-type-proof-total'), true);
        sumUp($elm.find('input.js-qt-input-prod'), $elm.find('.js-type-mass-total'), true);
        sumUp($elm.find('input.js-qt-input-manual'), $elm.find('.js-type-manual-total'), true);
      })

      // タイプごとの集計をカラーごとに集計
      sumUp($elm.find('.js-type-proof-total'), $elm.find('.js-prod-proof-total'), false);
      sumUp($elm.find('.js-type-mass-total'), $elm.find('.js-prod-mass-total'), false);
      sumUp($elm.find('.js-type-manual-total'), $elm.find('.js-prod-manual-total'), false);

    });
    // カラーごとの集計を全体集計
    sumUp($calcBlock.find('.js-prod-proof-total'), $calcBlock.find('.js-proof-total'), false);
    sumUp($calcBlock.find('.js-prod-mass-total'), $calcBlock.find('.js-mass-total'), false);
    sumUp($calcBlock.find('.js-prod-manual-total'), $calcBlock.find('.js-manual-total'), false);
  };

  return {
    rowMatchHeight: function() {
      $('.js-color-right-table tr:visible').each(function(i){

        const $rightCell = $(this).find('td');
        const $leftCell = $('.js-color-left-table tr:visible').eq(i).find('td');

        $rightCell.outerHeight('auto');
        $leftCell.outerHeight('auto');

        const rightHeight = $rightCell.outerHeight();
        const leftHeight = $leftCell.outerHeight();
        const alignedHeight = Math.max(rightHeight, leftHeight);

        $rightCell.outerHeight(alignedHeight);
        $leftCell.outerHeight(alignedHeight);
      });
      return this;
    },
    quantityClear: function() {
      $(document).on('click', '.js-qt-clear', function(e){
        $(this).closest('.js-qt-wrap').find('.js-qt-input-proof, .js-qt-input-prod, .js-qt-input-manual').not('[disabled]').val('').removeClass('is-input');
        calcTotal($(this));
        e.preventDefault();
      });
      return this;
    },
    //削除ボタンない場合は使わなくて良い
    deleteSelf: function() {
      $(document).on('click', '.js-qt-calc-delete', function(e){
        let $parent = $(this).closest(`.${qtCalcParentClassName}`);
        let number = $parent.data('productNumber');
        let $listItem = $(`.js-color-list-item[data-product-number="${number}"]`);
        $parent.remove();

        //リストアイテムのクリックを有効に
        $listItem.removeClass('selected');

        //消した要素内の削除ボタンを渡して小計を0に
        calcTotal($(this));
        e.preventDefault();
      });
      $(document).on('click', '.js-qt-calc-hide', function(e){
        let $parent = $(this).closest(`.${qtCalcParentClassName}`);
        let number = $parent.data('productNumber');
        let $listItem = $(`.js-color-list-item[data-product-number="${number}"]`);
        $parent.hide();

        // 入力済みの値を空にする
        $parent.find('.js-qt-input-proof, .js-qt-input-prod, .js-qt-input-manual').val('').removeClass('is-input');

        //リストアイテムのクリックを有効に
        $listItem.removeClass('selected');

        //消した要素内の削除ボタンを渡して小計を0に
        calcTotal($(this));
        e.preventDefault();
      });
      return this;
    },
    //数量の入力と増減できる機能
    quantityOperation: function($parentElm) {
      const adjustedValue = function (value, min, max) {
        if (value === '') {
          return value;
        }

        value = toNumber(value);

        const _min = toNumber(min),
          _max = toNumber(max);

        if (value < _min) {
          value = _min;
        } else if ((max !== null && max !== undefined) && value > _max) {
          value = _max;
        }

        return value;
      };

      $(document).on('click', '.js-qt-incr', function(e){
        const $target = $(this).closest('.js-qt-wrap').find('.js-qt-input-proof, .js-qt-input-prod, .js-qt-input-manual');

        if (isDisabled($target)) {
          return false;
        }

        $target
          // 計算した値をセットする。 min / max 判定は trigger('input') の処理で行う
          .val(toNumber($target.val()) + 1)
          .trigger('input');
      });
      $(document).on('click', '.js-qt-decr', function(e){
        const $target = $(this).closest('.js-qt-wrap').find('.js-qt-input-proof, .js-qt-input-prod, .js-qt-input-manual');

        if (isDisabled($target)) {
            return false;
        }

        $target
          // 計算した値をセットする。 min / max 判定は trigger('input') の処理で行う
          .val(toNumber($target.val()) - 1)
          .trigger('input');
      });


      let composingFlg = false;
      $(document).on('input compositionstart compositionupdate compositionend', '.js-qt-input-proof, .js-qt-input-prod, .js-qt-input-manual', function(e){
        if(e.type === 'compositionstart' || e.type === 'compositionupdate'){
          composingFlg = true
        }
        if(e.type === 'compositionend'){
          composingFlg = false
        }

        if(isDisabled($(this)) || composingFlg){
          return false;
        }

        const val = adjustedValue($(this).val(), 0, $(this).data('max'));

        $(this).val(val).toggleClass('is-input', !(val === ''));

        calcTotal($(this));
      });

      return this;
    },
    //仕上げオプション画面モーダル
    onModalOperate: function() {
      //.js-fin-op-qtはモーダルと合計出力箇所両方の親
      let $parent = $('.js-fin-op-qt');
      let $target = $parent.find('.js-qt-calc-wrap').find('.js-qt-input-proof, .js-qt-input-prod, .js-qt-input-manual');

      $parent.on('qt-confirmed', function() {
        // 仕上げ数の変更確定を発火する
        $(this).trigger('qt-confirmed-variables', {
          proof: {
            total: toNumber($parent.find('.js-estimated-proof-total').text()),
            'fin-total': toNumber($parent.find('.js-fin-proof-total').text())
          },
          mass: {
            total: toNumber($parent.find('.js-estimated-mass-total').text()),
            'fin-total': toNumber($parent.find('.js-fin-mass-total').text())
          },
          manual: {
            total: toNumber($parent.find('.js-estimated-manual-total').text()),
            'fin-total': toNumber($parent.find('.js-fin-manual-total').text())
          },
        });
      });

      const applyTotalOutsideModal = ($elm) => {
        //モーダル外画面合計出力箇所に合計値設定
        $('.js-fin-proof-total').text($elm.find('.js-proof-total').text());
        $('.js-fin-mass-total').text($elm.find('.js-mass-total').text());
        $('.js-fin-manual-total').text($elm.find('.js-manual-total').text());
      };

      //「決定する」ボタン押して閉じるとき
      $(document).on('click', '.js-confirm-qt-edit', function(){
        //モーダル外画面合計出力箇所に合計値設定
        applyTotalOutsideModal($(this).closest('.js-modal').find('.js-qt-calc-wrap'));
        //現状の値をdata-prev-valに保存
        $target.each(function(){
          $(this).data('prev-val', $(this).val());
        });

        $parent.trigger('qt-confirmed');
      });

      //「閉じる」ボタンorオーバーレイ押して閉じるとき
      $(document).on('click', '.js-cancel-qt-edit', function(e){
        if($(e.target).closest('.js-modal-close').length || !$(e.target).closest('.js-modal-inner').length){
          //data-prev-valに保存している値を現状の値にする
          $target.each(function(){
            $(this).val($(this).data('prev-val'));
          }).end().eq(0).trigger('input');
        }
      });
      return this;
    },
    initialSetting: function($parentElm){
      $parentElm.each((index, elm) => $(elm).find('.js-qt-input-proof, .js-qt-input-prod, .js-qt-input-manual').eq(0).trigger('input'));
    }
  }
})();

//プリント加工方法選択ボックス開閉
var methodBox = () => {
  var $trg = $('.js-method-radio');
  var $parent = $('.js-method-box');
  var $body = $('.js-method-box-body');

  $trg.on('change', function(){
    var $targetBody = $(this).closest($parent).find($body);
    if($(this).prop('checked')){
      $targetBody.stop().slideDown(commonValues.accordionSpeed);
    }else{
      $targetBody.stop().slideUp(commonValues.accordionSpeed);
    }
    $trg.not(':checked').closest($parent).find($body).slideUp(commonValues.accordionSpeed);
  }).trigger('change');
};


//デザインサイズUI表示切り替え
var designSizeUserInterface = () => {

  //サイズごとのwh入力エリアトグル
  var whAreaToggle = (() => {
    $('.js-design-size-wh').hide();
    var $checked = $('.js-design-size-check').filter(':checked');
    $checked.closest('.js-design-size-type').find('.js-design-size-wh').show();

    $(document).on('change', '.js-design-size-check', function(){
      var $notChecked = $('.js-design-size-check').not(':checked');
      $notChecked.closest('.js-design-size-type').find('.js-design-size-wh').stop().slideUp(commonValues.accordionSpeed);
      $(this).filter(':checked').closest('.js-design-size-type').find('.js-design-size-wh').stop().slideDown(commonValues.accordionSpeed);
    });
  })();

  //1サイズor複数サイズでの表示切り替え
  var setSingleMulti = (() => {

    $(document).on('change', '.js-single-multi-radio', function(){
      var $parent = $(this).closest('.js-design-size-wrap');
      $parent.find('.js-design-size-set').addClass('is-show');
      if($(this).hasClass('single-size')){
        $parent.find('.js-design-size-type').filter('.secondary-size').stop().slideUp(commonValues.accordionSpeed, function(){
          $(this).height('auto');
        });
        var $primarySize = $parent.find('.js-design-size-type').filter('.primary-size');
        $primarySize.find('.js-design-size-check').prop('checked', true)
          .closest('.js-design-size-type').find('.js-design-size-wh').show();
        $primarySize.stop().slideDown(commonValues.accordionSpeed, function(){
          $(this).height('auto');
        });
      }else if($(this).hasClass('multi-size')){
        $parent.find('.js-design-size-type').stop().slideDown(commonValues.accordionSpeed, function(){
          $(this).height('auto');
        });
      }
    });

    $('.js-design-size-type').hide();
    $('.js-single-multi-radio').filter(':checked').trigger('change');
  })();
};

//デザインサイズフォーム入力フォーム
var designSizeInput = () => {
  $(document).on('change blur keyup', '.js-wh-input-mod .js-wh-input', function(){
    var context = $(this).closest('.js-design-size-type');
    if($(this).val() <= 0){
      $(this).val('');
      $('.js-design-size-area', context).text('');
      return false;
    }

    var width = toNumber($('.js-wh-input-width', context).val());
    var height = toNumber($('.js-wh-input-height', context).val());
    if (width && height) {
      $('.js-design-size-area', context).text(width * height);
    }
  });
  $('.js-wh-input-mod .js-wh-input').trigger('change');

  $(document).on('click', '.js-wh-input-mod .js-wh-incr', function(){
      var $target = $(this).closest('.js-wh-input-mod').find('.js-wh-input');
      if (isDisabled($target)) {
          return false;
      }

      var temp = toNumber($target.val()) + 1;
      $target.val(temp);
      $target.trigger('change');
  });
  $(document).on('click', '.js-wh-input-mod .js-wh-decr', function(){
      var $target = $(this).closest('.js-wh-input-mod').find('.js-wh-input');
      if (isDisabled($target)) {
          return false;
      }

      var temp = toNumber($target.val()) - 1;
      if (temp < 0) {
          temp = 0;
      }
      $target.val(temp);
      $target.trigger('change');
  });
};

/*
  仕上げオプション画面 オプション設定エリア
  チェックボックスヘッダーホバー時のみ、エリアのボーダー色が変更する
*/
const optionSettingBoxHover = function(){
  const $header = $('.js-op-setting-hd');
  const $box = $('.js-op-setting-box');
  const $checkBox = $header.find('input[type="checkbox"]');
  const $label = $header.find('label');
  $header.on('mouseenter', function(){
    if($(this).find($checkBox).is('[disabled]') || $(this).find($label).hasClass('disabled')){
      return false;
    }
    $(this).closest($box).addClass('hovered');
  }).on('mouseleave', function(){
    if($(this).find($checkBox).is('[disabled]') || $(this).find($label).hasClass('disabled')){
      return false;
    }
    $(this).closest($box).removeClass('hovered');
  });
}

/*
  仕上げオプション画面枚数増減フォーム
  カラーサイズ選択画面、仕上加工オプション画面のサイズの数量の選択の増減フォームとは別
*/
var inputNumIncrAndDecr = function(){
  var $parent = $('.js-incr-decr-mod');
  var $incrBtn = $parent.find('.js-input-num-incr');
  var $decrBtn = $parent.find('.js-input-num-decr');
  var $input = $('.js-incr-decr-input');

  $incrBtn.on('click', function(e){
    var $target = $(this).closest($parent).find($input);
    if (isDisabled($target)) {
        return false;
    }

    var tmp = toNumber($target.val()) + 1;
    $target.val(tmp);
  });
  $decrBtn.on('click', function(e){
    var $target = $(this).closest($parent).find($input);
    if (isDisabled($target)) {
        return false;
    }
    var tmp = toNumber($target.val()) - 1;
    if(tmp < 0){
      tmp = 0;
    }
    $target.val(tmp);
  });
  $input.on('input', function(){
    var tmp = toNumber($(this).val());
    if(tmp < 0){
      $(this).val('0');
    }else if($(this).val() === ''){
      $(this).val(null);
    }else{
      $(this).val(tmp);
    }
  });
};

//データ入稿画面プリントカラー選択
const printColorSelect = function(){
  $('.js-print-color-select-block').each(function () {
    const $colorTipBlock = $('.js-color-select-tip-block', this),
      $selectedColorName = $('.js-selected-color-name', this),
      $colorTip = $('.js-color-select-tip', this),
      $colorTipInput = $('.js-color-select-tip-input', this),
      $exceptRegularCheck = $('.js-except-regular-check', this);

    $colorTip.on('click', function(e){
    　// e.isTrigger は user interaction 時にはプロパティが存在しない
    　// 初期化時などの $().trigger() で呼ばれた場合は処理を続ける
      if(isDisabled($colorTipBlock.find('ul')) && !e.isTrigger){
        return false;
      }
      $colorTip.removeClass('selected');
      $(this).addClass('selected');

      $colorTipInput.val($(this).data('id'));
      $selectedColorName.text(
          ($(this).hasClass('js-normal-color') ? '通常：' : '') + $(this).data('name')
      ).addClass('selected');
    });

    //データ入稿画面 規定色以外カラーコード選択プルダウン
    const $colorCodeSelector = $('.js-color-code-select', this);

    $colorCodeSelector.select2({
      placeholder: '',
      theme: 'theme-suggest-select',
      width: '100%',
      language: {
        noResults: function () {
          //colorCodeNoResultsTextはHTMLで定義
          if(typeof colorCodeNoResultsText !== 'undefined'){
            return colorCodeNoResultsText;
          }else{
            return '';
          }
        }
      }
    });

    $colorCodeSelector.on('select2:select', function (e) {
      const $block = $(this).closest('.js-print-color-select-block');
      const colorType = ($block.find('.js-normal-color-type').find(':selected').text() || "").toUpperCase();

      // @var e event data
      // https://select2.org/programmatic-control/events
      $block.find('.js-selected-color-name').text(colorType + '：' + e.params.data.text).addClass('selected');
    });

    $colorCodeSelector.on('select2:opening', function (e) {
        return !$(e.currentTarget).hasClass('disabled');
    });

    const selectedDicOrPantone = function () {
        const $selector = $colorCodeSelector.filter(':visible');
        if (!$selector.length) {
            return;
        }

        $selector.trigger({
            type: 'select2:select',
            params: {
              data: $selector.select2('data')[0] || {}
            }
        });
    }

    $exceptRegularCheck.on('change', function(){
      const checked = $(this).prop("checked");
      //style用にattrでdisabled設定
      $colorTipBlock.find('ul').attr('disabled', checked);

      if (checked) {
        selectedDicOrPantone();
      } else {
        $colorTip.filter('.selected').trigger('click');
      }
    });

    $('.js-normal-color-type', this).change(function() {
      var colorType = $(this).val();
      var $content = $(this).closest('.js-check-accd-body');
      $('.js-color-code-select', $content).closest('div').hide();
      $('.js-color-code-select-' + colorType, $content).closest('div').show();

      selectedDicOrPantone();
    }).change();

    // 初期化
    $colorTip.filter(`[data-id="${$colorTipInput.val()}"]`).addClass('selected').trigger('click');
    $exceptRegularCheck.trigger('change');
  });
}

//データ入稿画面 規定色以外カラーコード選択プルダウン
var colorCodeSelect = function(){
  //ホバー時タイトル属性空に ツールチップ非表示用
  $(document).on('mouseenter', '.select2-selection__rendered', function(){
      $(this).attr('title', '');
  });
}

//発注手続き画面 直送先一覧から選択入力
var inputFromSavedDirect = () => {
  var scrPos = 0;
  var $currentBlock;

  // モーダル部分の開閉 汎用のものとは別
  $('.js-direct-modal-open').on('click', function(){
    scrPos = $(window).scrollTop();
    if(!$('.js-direct-modal').length){
      return false;
    }
    //値をセットするフォームがあるブロックの親要素を代入しておく
    $currentBlock = $(this).closest('.js-direct-parent');
    $('.js-direct-modal').fadeIn();
    $('body').css({
      'top': -scrPos,
      'height': `calc(100% + ${scrPos}px)`
    }).addClass('is-fixed');
    $('.js-sp-hd-middle').addClass('is-body-fixed');
  });
  $('.js-direct-modal-close, .js-direct-modal').on('click', function(e){
    if($(e.target).closest('.js-direct-modal-close').length || !$(e.target).closest('.js-direct-modal-inner').length){
      var $target = $(this).hasClass('js-direct-modal-close') ? $(this).closest('.js-direct-modal') : $(this);
      $target.fadeOut(function(){
        $('body').css({
          'height': 'auto'
        }).removeClass('is-fixed');
        $('.js-sp-hd-middle').removeClass('is-body-fixed');
        $(window).scrollTop(scrPos);
      });
    }
  })

  //選択されている直送先の値をフォームにセット
  var $btn = $('.js-btn-input-direct-address');
  $btn.on('click', function(){
    var $selected = $(this).closest('.js-parent-input-direct-address').find('input[type="radio"]').filter(':checked');
    if(!$selected.length){
      return;
    }
    var $inputs = $currentBlock.find('input');
    $inputs.filter('.js-input-company').val($selected.data('company'));
    $inputs.filter('.js-input-postalcode').val($selected.data('postalcode'));
    $inputs.filter('.js-input-city').val($selected.data('city'));
    $inputs.filter('.js-input-building').val($selected.data('building'));
    $inputs.filter('.js-input-name').val($selected.data('name'));
    $inputs.filter('.js-input-tel').val($selected.data('tel'));

    //都道府県select入力
    $currentBlock.find('.js-select-pref').val($selected.data('prefcode'));
  })

  //絞り込み表示
  var $addressList = $('.direct-address-list');
  var $addressItem = $('.direct-address-list .address-item');
  $('.js-direct-search').quicksearch($addressItem, {
    selector:'.campany, .postal-code, .tel',
    show: function () {
      $(this).removeClass('is-hide');
    },
    hide: function () {
      $(this).addClass('is-hide');
    },
    onAfter: function(){
      var isHideAll = !$addressItem.not('.is-hide').length;
      $addressList.toggleClass('hide-all', isHideAll);
    }
  });
};

//サムネイル付きプルダウン
$.fn.thumbPull = function(options) {
    const isNotEmpty = function (data) {
            // 空文字列の場合は empty では無い
            return !!data || data === '';
        };
    const selector = this,
        $globalUl = $('.js-thumb-select-ul');

    options = options || {};
    this.each(function() {
        const $this = $(this),
            $select = $this.find('.js-thumb-select'),
            $box = $this.find('.js-thumb-select-div'),
            $ul = $this.find('.js-thumb-select-ul'),
            liHtml = `<li class="thumb-select-mod__dummy-item js-thumb-select-item">
                        <div class="thumb-select-mod__dummy-img-wrap js-thumb-select-img-wrap">
                            <img class="thumb-select-mod__dummy-img js-thumb-select-img" src="">
                            <span></span>
                        </div>
                        <span class="thumb-select-mod__dummy-txt">
                            <span class="thumb-select-mod__dummy-placeholder js-thumb-select-placeholder"></span>
                            <span class="thumb-select-mod__dummy-ttl js-thumb-select-ttl"></span>
                            <span class="thumb-select-mod__dummy-desc js-thumb-select-desc"></span>
                        </span>
                    </li>`,
            $liTemplate = $(liHtml);

        $ul.children().remove();

        $select.find('option').not(':disabled').each(function () {
            const $li = $liTemplate.clone();

            $li.data('value', $(this).val());

            isNotEmpty($(this).data('placeholder')) ?
                $li.find('.js-thumb-select-placeholder').text($(this).data('placeholder')) : $li.find('.js-thumb-select-placeholder').remove();

            //画像部分 img要素で出力するか背景画像で出力するか画像部分なしか出し分け
            if (isNotEmpty($(this).data('img'))) {
                $li.find('.js-thumb-select-img').attr('src', $(this).data('img'));
                //img要素使用時は背景画像用のspan要素を削除
                $li.find('.js-thumb-select-img-wrap').find('span').remove();
            } else if (isNotEmpty($(this).data('iconclass'))) {
                $li.find('.js-thumb-select-img-wrap').find('span').addClass($(this).data('iconclass'));
                //スタイル背景画像用のHTMLクラス設定時はimg要素は削除
                $li.find('.js-thumb-select-img-wrap').find('img').remove();
            } else {
                $li.find('.js-thumb-select-img-wrap').remove();
            }

            isNotEmpty($(this).data('title')) ?
                $li.find('.js-thumb-select-ttl').text($(this).data('title')) : $li.find('.js-thumb-select-ttl').remove();

            isNotEmpty($(this).data('description')) ?
                $li.find('.js-thumb-select-desc').text($(this).data('description')) : $li.find('.js-thumb-select-desc').remove();

            //既にselectedの場合、ダミー要素にselectedクラス付与、ダミーボックスにhtml設定
            if ($(this).prop('selected')) {
                $li.addClass('selected');
                $box.html($li.clone(false).html());
            }
            $ul.append($li);
            if ($(this).is('[disabled]')) {
                //style用にattrでdisabledを与える
                $box.attr('disabled', true);
            }
        });

        // 選択していた項目が無くなった場合に1つ目を選択中にする
        $select.val() === null && $ul.find('.js-thumb-select-item').eq(0).trigger('click.item');

        if (options['refresh']) {
            return;
        }

        $ul.hide();

        // global event listener
        $(document).off('click.thumbSelect').on('click.thumbSelect', function (e) {
            if (!$(e.target).closest($(selector)).length) {
                $globalUl.hide();
            }
        });

        // scoped event listener
        $box.off('click.ul').on('click.ul', function () {
            if ($(this).is('[disabled]')) {
                return false;
            }
            $globalUl.not($ul).hide();
            $ul.toggle();
        });

        $ul.off('click.item').on('click.item', '.js-thumb-select-item', function () {
            const html = $(this).html();

            $ul.find('.js-thumb-select-item').removeClass('selected');
            $(this).addClass('selected');
            $box.html(html);
            $ul.hide();

            $select.val() != $(this).data('value') && $select.val($(this).data('value')).trigger('change');
        });
    });
}

// 発注カラー入力画面 配色替えパターン切り替え

var switchColorChangePattern = () => {
    $('.js-switch-pattern .switch-pattern-button').on('click', function() {
        var $targetElm = $(this).closest('.order-design-pattern-wrap').find('.order-design-pattern-block');
        $(this).addClass('is-active');
        if ($(this).hasClass('pattern1')) {
            $targetElm.filter('.pattern1').stop().fadeIn().addClass('is-show');
            $targetElm.filter('.pattern2').stop().fadeOut().removeClass('is-show');
            $(this).closest('.switch-pattern').find('.pattern2').removeClass('is-active');
        } else if ($(this).hasClass('pattern2')) {
            $targetElm.filter('.pattern1').stop().fadeOut().removeClass('is-show');
            $targetElm.filter('.pattern2').stop().fadeIn().addClass('is-show');
            $(this).closest('.switch-pattern').find('.pattern1').removeClass('is-active');
        }
    });
    $('.order-design-pattern-block').filter('.pattern2').css({'display': 'none'});
    $('.js-switch-pattern .switch-pattern-button').filter('.pattern1').trigger('click');
}
